
<div class="main-container">
  <div class="navigation-breadcrumb">
  <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
    {{ VendorListEnum.Breadcrumb }}
  </span>
</div>
<div class="vendors-list-container">
  <div class="vendors-tab-table-container">
    <emerald-tab-bar [tabsData]="tabsData" (selectedTabChange)="onTabChange($event)"></emerald-tab-bar>
    <div class="tab-table-divider"></div>
    <emerald-datatable class="vendors-table" [columnDefs]="currentColumnDefs" [rowData]="currentRowData"
      [paginationParams]="paginationParams" [customCellTemplate]="{
        vendor: vendorCell,
        address: addressCell,
        email: emailCell,
      }">
    </emerald-datatable>
  </div>
</div>

<ng-template #documentsCell let-row="row" let-col="col">
  <div class="icon-cell">
    <emerald-icon icon="download" [style]="'round'" class="icon-center"></emerald-icon>
  </div>
</ng-template>

<ng-template #addressCell let-level="level" let-eachRow="eachRow">
  <div class="address-cell" [title]="eachRow?.address">
    {{ truncateText(eachRow?.address, 18) }}
  </div>
</ng-template>

<ng-template #emailCell let-level="level" let-eachRow="eachRow">
  <div class="email-cell" [title]="eachRow?.email">
    {{ truncateText(eachRow?.email, 18) }}
  </div>
</ng-template>

<ng-template #vendorCell let-level="level" let-eachRow="eachRow">
  <div class="name">
    <a href="">{{ eachRow?.vendor }}</a>
  </div>
</ng-template>
</div>

<!-- <ng-template #actionCell let-row="row" let-col="col" let-rowIndex="rowIndex">
  <div [ngClass]="{
      'icon-cell actions-icons': selectedTab.key === 'updateRequests',
      'icon-cell': selectedTab.key !== 'updateRequests',
      'actions-icons': true
    }">
    <ng-container *ngIf="selectedTab.key === 'updateRequests'; else moreVertIcon">
      <span class="action-icon-wrapper" (click)="onDropdownMenuAction(row, 'approve')">
        <emerald-icon icon="check" [style]="'round'" class="icon-center"></emerald-icon>
        <emerald-icon [icon]="'arrow_drop_down'" class="dropdown-arrow"></emerald-icon>
      </span>
      <span class="action-icon-wrapper" (click)="onDropdownMenuAction(row, 'reject')">
        <emerald-icon icon="close" [style]="'round'" class="icon-center"></emerald-icon>
        <emerald-icon [icon]="'arrow_drop_down'" class="dropdown-arrow"></emerald-icon>
      </span>
    </ng-container>
    <ng-template #moreVertIcon>
      <span class="action-icon-wrapper" (click)="onActionClick(rowIndex, $event)">
        <emerald-icon icon="more_vert" [style]="'round'" class="icon-center"></emerald-icon>
      </span>
    </ng-template>
    <div *ngIf="showDropdown && dropdownRowIndex === rowIndex"
      class="dropdown-backdrop" (click)="showDropdown = false">
    </div>
    <div *ngIf="showDropdown && dropdownRowIndex === rowIndex"
      class="dropdown-menu" [ngStyle]="dropdownPosition" (click)="$event.stopPropagation()">
      <div class="dropdown-item"
           *ngFor="let option of dropdownOptions"
           (click)="onDropdownMenuAction(row, option.value); $event.stopPropagation()">
        {{ option.label }}
      </div>
    </div>
  </div>
</ng-template> -->